// extracted by mini-css-extract-plugin
export var actionText = "_qr-4";
export var container = "_qr-0";
export var leftSection = "_qr-1";
export var rightSection = "_qr-2";
export var settingsButton = "_qr-6";
export var settingsIcon = "_qr-7";
export var shortcut = "_qr-5";
export var shortcutGroup = "_qr-3";